import Heading from "components/Heading/Heading";
import { Button, Form, Modal, message } from "antd";
import { useState } from "react";
import DataTable from "../../../components/Tables/DataTable";
import FormModal from "./FormModal";
import {
  useAddCustomerMutation,
  useDeleteCustomerMutation,
  useGetCustomersQuery,
  useEditCustomerMutation,
} from "../../../redux/Service/customersApi";
import dayjs from "dayjs";
import { useGetAccountsQuery } from "../../../redux/Service/Accounts";
import { useGetCurrenciesQuery } from "../../../redux/Service/currenciesApi";
import { useGetSellersQuery } from "../../../redux/Service/sellersApi";
import { useGetCustomerTypesQuery } from "../../../redux/Service/CustomerTypesApi";

function CutomersCodes() {
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  const { data: customersData, isLoading } = useGetCustomersQuery(undefined);
  const customers = customersData?.ResponseObject ?? [];

  const { data: accountsData } = useGetAccountsQuery(undefined);
  const accounts = accountsData?.ResponseObject ?? [];

  const { data: currenciesData } = useGetCurrenciesQuery(undefined);
  const currencies = currenciesData?.ResponseObject ?? [];

  const { data: customerTypesData, isLoading: isCustomerTypesLoading } =
    useGetCustomerTypesQuery(undefined);
  const customerTypes = customerTypesData?.ResponseObject ?? [];

  const {
    data: sellersData,
    isLoading: issellersLoading,
    isError: issellersError,
  } = useGetSellersQuery(undefined);

  const sellers = sellersData?.ResponseObject ?? [];

  const [deleteCustomer, { isLoading: isDeleting }] =
    useDeleteCustomerMutation();
  const [addCustomer, { isLoading: isAdding }] = useAddCustomerMutation();
  const [updateCustomer, { isLoading: isUpdating }] = useEditCustomerMutation();

  const handleDeleteClick = (record: any) => {
    Modal.confirm({
      title: "تأكيد الحذف",
      content: `هل أنت متأكد أنك تريد حذف العميل "${record.CustomerName}"؟`,
      okText: "حذف",
      okType: "danger",
      cancelText: "إلغاء",
      onOk: async () => {
        try {
          const response = await deleteCustomer(record.CustomerID).unwrap();
          if (response?.ResponseObject === true) {
            message.success("تم حذف العميل بنجاح");
          } else {
            message.error("حدث خطأ أثناء الحذف");
          }
        } catch {
          message.error("فشل الاتصال بالخادم");
        }
      },
    });
  };

  const handleOk = async (values) => {
    const body = {
      ...values,
      FirstBalDate: values.FirstBalDate?.format("YYYY-MM-DD"),
    };

    try {
      const response = isEditing
        ? await updateCustomer(body).unwrap()
        : await addCustomer(body).unwrap();

      if (response?.ResponseObject === true) {
        message.success(
          isEditing ? "تم تعديل العميل بنجاح" : "تمت إضافة العميل بنجاح"
        );
        form.resetFields();
        setIsEditing(false);
        setIsModalOpen(false);
      } else {
        message.error("حدث خطأ أثناء العملية");
      }
    } catch {
      message.error("فشل الاتصال بالخادم");
    }
  };

  const handleEditClick = (record: any) => {
    setIsEditing(true);
    setIsModalOpen(true);
    const recordData = { ...record };
    if (recordData.FirstBalDate) {
      recordData.FirstBalDate = dayjs(recordData.FirstBalDate);
    }
    form.setFieldsValue(recordData);
  };

  const columns = [
    { title: "كود العميل", dataIndex: "CustomerID", key: "CustomerID" },
    { title: "اسم العميل", dataIndex: "CustomerName", key: "CustomerName" },
    { title: "الهاتف", dataIndex: "Phone", key: "Phone", width: 150 },
    { title: "الموبايل", dataIndex: "Mobile", key: "Mobile", width: 150 },
    { title: "العنوان", dataIndex: "Address", key: "Address" },
    {
      title: "تاريخ الرصيد",
      dataIndex: "FirstBalDate",
      key: "FirstBalDate",
      render: (date: string) => dayjs(date).format("YYYY-MM-DD"),
    },
  ];

  return (
    <>
      <Heading name="العملاء" />
      <div className="flex flex-wrap gap-4 relative">
        <div className="grid justify-start">
          <Button type="primary" onClick={() => setIsModalOpen(true)}>
            إضافه
          </Button>
        </div>

        <FormModal
          form={form}
          isEditing={isEditing}
          isModalOpen={isModalOpen}
          handleOk={handleOk}
          handleCancel={() => {
            setIsModalOpen(false);
            form.resetFields();
            setIsEditing(false);
          }}
          initialValues={{ FirstBal: 0, FirstBalDate: dayjs(new Date()) }}
          loading={isAdding || isUpdating}
          accounts={accounts}
          currencies={currencies}
          sellers={sellers}
          customerTypes={customerTypes}
        />

        <DataTable
          columns={columns}
          data={customers}
          handleEditClick={handleEditClick}
          handleDeletClick={handleDeleteClick}
          isLoading={isLoading || isDeleting}
        />
      </div>
    </>
  );
}

export default CutomersCodes;
